import script from "./dynamicList.vue?vue&type=script&setup=true&lang=js"
export * from "./dynamicList.vue?vue&type=script&setup=true&lang=js"

import "./dynamicList.vue?vue&type=style&index=0&id=6d36f66e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d36f66e"]])

export default __exports__